const zipCode = "XXXXX"
const phone = "+1 (XXX) XXX-XXXX"
const email = "example@ezbuild.com"
const website = "https://example.com"
const taxNumber = "XX-XXXXXXX"

const placeholders = {
  zipCode,
  phone,
  email,
  website,
  taxNumber
}

const empty = "-"

export { placeholders, empty }
